import(/* webpackMode: "eager" */ "/app/app/supplier/page.tsx");
